/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 5/11/2023
 */

import BaseObject from "@shared/BaseObject.js";

export default class PortalRef extends BaseObject {

	ownerId: string = null
	userAuthId: string = null //user id in auth system
	userId: string = null 	//user id in the owner account record

	ownerTitle: string = null
	role: string = null


	constructor() {
		super();
	}




}
